import { z } from "zod";
import { passwordSchema } from "./passwordValidator";

export const createAprendizWithUserSchema = z.object({
  usuario: z.object({
    nombreUsuario: z.string().min(2, "Nombre de usuario requerido"),
    correo: z.string().email("Correo inválido"),
    contrasena: passwordSchema,
    nombre: z.string().min(1, "Nombre requerido"),
    apellidoPaterno: z.string().min(1, "Apellido paterno requerido"),
    apellidoMaterno: z.string().optional(),
    idRol: z.literal(4),
  }),
  aprendiz: z.object({
    idClienteFinal: z.number().min(1, "Id del cliente final requerido"),
  }),
});

export type CreateAprendizWithUserInput = z.infer<
  typeof createAprendizWithUserSchema
>;
